import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';

import AdminAthletesPageHeader from './components/AdminAthletesPageHeader';
import AdminAthletesTableContainer from './components/AdminAthletesTableContainer';

interface FilterTerms {
  searchTerm: string;
  isArrangeByLastName: boolean;
  athleteStatus: string;
  loginEnabled: string;
}

const AdminAthletesPage = (): JSX.Element => {
  const initialSearchFiltersValue = {
    searchTerm: '',
    isArrangeByLastName: false,
    athleteStatus: '',
    loginEnabled: '',
  };

  const [searchFilters, setSearchFilters] = useState<FilterTerms>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<FilterTerms>(searchFilters, 250);

  return (
    <>
      <AdminAthletesPageHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
      />

      <AdminAthletesTableContainer searchFilters={debouncedSearchFilters} />
    </>
  );
};

export default AdminAthletesPage;
